/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:56
 */
import Column from "./Column";

class TypeColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

  static label(value) {
    value = value
      .replace(/\-/g, ' ')
      .replace(/_/g, ' ');

    return value.substring(0, 1).toUpperCase() + value.substring(1);
  }

}

export default TypeColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/TypeColumn.js